import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';

// openDialogWithAResult
@Component({
  selector: 'confirm-deleteLocation-dialog',
  template: `<h4 md-dialog-title>Warning!</h4>
  <div md-dialog-content style="padding-bottom: 20px;">Deleting the location will permanently delete this location. <br> Do you want to continue?</div>
  <div md-dialog-actions>
    <button mat-button (click)="dialogRef.close('cancel')">Cancel</button>
    <button mat-button (click)="dialogRef.close('confirm')">Delete</button>
  </div>`,
})
export class ConfirmDeleteLocationDialogComponent {
  constructor(public dialogRef: MatDialogRef<ConfirmDeleteLocationDialogComponent>) {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/customers/home/confirm-deleteLocation-dialog.component.ts